(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace-competition/services/assets/hooks/use-wagers.js') >= 0) return;  svs.modules.push('/components/marketplace-competition/services/assets/hooks/use-wagers.js');
"use strict";


const _React = React,
  useEffect = _React.useEffect;
const _ReactRedux = ReactRedux,
  useDispatch = _ReactRedux.useDispatch,
  useSelector = _ReactRedux.useSelector;
const _svs$components$marke = svs.components.marketplaceCompetition.services,
  fetchWagers = _svs$components$marke.actions.wagersActions.fetchWagers,
  selectWagers = _svs$components$marke.selectors.wagersSelectors.selectWagers;

const useWagers = competitionId => {
  const dispatch = useDispatch();
  const wagers = useSelector(state => selectWagers(state, competitionId));
  useEffect(() => {
    if (!wagers && competitionId) {
      dispatch(fetchWagers(competitionId));
    }
  }, [wagers, competitionId, dispatch]);
  return wagers;
};

setGlobal('svs.components.marketplaceCompetition.services.hooks.useWagers', useWagers);

 })(window);